module.exports = __webpack_public_path__ + "static/img/btn_playstore.af9f09a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_playstore.png
// module id = Fu1r
// module chunks = 1